import { Notifications } from "@mantine/notifications";
import { UiUpdates } from "./UiUpdates";
import { Auth } from "./Auth";
import { Api } from "./Api";
import { Routing } from "./Routing";
import { Partner } from "./Partner";
import { PlaylistLogic } from "./PlaylistLogic";
import { AssignmentLogic } from "./AssignmentLogic";
import { RecommendationLogic } from "./RecommendationLogic";

export const LogicWrapper = ({
  children,
  isEmbed,
}: {
  children: React.ReactNode;
  isEmbed: boolean;
}) => {
  return (
    <>
      {!isEmbed && <UiUpdates />}
      {!isEmbed && <Auth />}
      {!isEmbed && <RecommendationLogic />}
      {!isEmbed && <Notifications />}
      {!isEmbed && <Api />}
      {!isEmbed && <Partner />}
      {!isEmbed && <PlaylistLogic />}
      {!isEmbed && <AssignmentLogic />}
      <Routing />
      {children}
    </>
  );
};
